import {useQuery} from '@tanstack/react-query';
import {rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {RQ_GET_CONSOLIDATED_REPORT_API} from '@app/reactQuery/apis/constants';

export const RQUseGetConsolidatedReportsData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_consolidate_reports_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, divisionId, yearMonth} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_CONSOLIDATED_REPORT_API,
        null,
        certificate,
        {divisionId: divisionId,
          yearMonth:yearMonth},
        signal,
      );
    },
    ...options,
  });
};
